import React from "react"
import Carousel from "nuka-carousel"
import PropTypes from "prop-types"

import Ad from "../Ad/Ad"
import Question from "../Question/Question"
import PagingDots from "../PagingDots/PagingDots"
import "./QuizCarousel.module.scss"

const QuizCarousel = ({
    data,
    handleClick,
    slideIndex,
    setSlideIndex,
    reTakeIndex,
}) => {
    const settings = {
        vertical: true,
        renderCenterRightControls: null,
        renderCenterLeftControls: null,
        heightMode: "max",
        cellSpacing: 20,
        slideIndex,
        afterSlide: slideInd => setSlideIndex(slideInd),
        renderBottomCenterControls: props => <PagingDots {...props} />,
    }

    return (
        <Carousel {...settings} initialSlideHeight={420}>
            {data.map((ques, index) => {
                if (ques.questions.question === "ad") {
                    return (
                        <Ad
                            key={ques.questions.question_id}
                            handleClick={handleClick}
                            number={ques.questions.adNumber}
                            index={index}
                            id={`${ques.questions.question_id}${
                                reTakeIndex || ""
                            }`}
                        />
                    )
                }
                return (
                    <Question
                        key={ques.questions.question_id}
                        number={ques.questions.number}
                        question={ques.questions.question}
                        quesId={ques.questions.question_id}
                        index={index}
                        handleClick={handleClick}
                        option1={ques.questions.option1}
                        option2={ques.questions.option2}
                        option3={ques.questions.option3}
                        option4={ques.questions.option4}
                    />
                )
            })}
        </Carousel>
    )
}

QuizCarousel.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            questions: PropTypes.shape({
                option1: PropTypes.shape({
                    results: PropTypes.string.isRequired,
                    label: PropTypes.string.isRequired,
                }),
                option2: PropTypes.shape({
                    results: PropTypes.string.isRequired,
                    label: PropTypes.string.isRequired,
                }),
                option3: PropTypes.shape({
                    results: PropTypes.string.isRequired,
                    label: PropTypes.string.isRequired,
                }),
                option4: PropTypes.shape({
                    results: PropTypes.string.isRequired,
                    label: PropTypes.string.isRequired,
                }),
                question: PropTypes.string.isRequired,
                question_id: PropTypes.string.isRequired,
            }),
        })
    ),
    handleClick: PropTypes.func.isRequired,
    slideIndex: PropTypes.number.isRequired,
    setSlideIndex: PropTypes.func.isRequired,
}

export default QuizCarousel
